// extracted by mini-css-extract-plugin
module.exports = {"button":"Button-module--button--14gIY","loader":"Button-module--loader--FFKzO","spin":"Button-module--spin--2hEa_","buttonLoading":"Button-module--buttonLoading--3Fsy7"};